const Emitter = require('mn-utils/Emitter');
const {
  popup$,
} = require('./popup');
const {
  backLocation,
} = require('../router');

export const removeOpen$ = popup$.is('remove');
export const removeCallback$ = new Emitter();
export const remove$ = Emitter.some([
  removeOpen$,
  removeCallback$,
]);


export function confirmRemove(callback) {
  removeCallback$.emit(callback);
  removeOpen$.emit(1);
}

removeOpen$.getValue() && backLocation();
